// extracted by mini-css-extract-plugin
export default {"wrapper":"PromoCodePills-module__wrapper___17--P","pill":"PromoCodePills-module__pill___3yIZH","text":"PromoCodePills-module__text___2Tk2M"};